import React from "react";
import { useSelector } from "react-redux";
import projectDefaultIcon from "../../assets/icons/icon-project.png";
import { Spinner } from "../../components/Loading";
import { useScope } from "../SelectProjectCompanyContainer";
import { isMobile } from "react-device-detect";

const SelectCompanyMobileContainer = ({ openCompanyMenu, setOpenCompanyMenu, collapsed }) => {
  const { scope, scopeName } = useScope();
  const projects = useSelector((state) => state.app.projects || []);

  const getCompanies = async () => {
    if (!collapsed) {
      setOpenCompanyMenu(true);
    }
  };

  return (
    <div className="select-sidebar-container">
      <div className={`select-sidebar__option${!openCompanyMenu ? " select-sidebar__option--project-menu" : ""}`}>
        <div className="select-sidebar__option-content" style={{ backgroundColor: "#f2f2f2", marginTop:"0rem"}}>
          {projects?.length ? (
            <>
              <div
                className="select-sidebar__option-project-info"
                onClick={() => getCompanies()}
                title={`${scopeName}`}
              >
                <div className="select-sidebar__option-project-info-image">
                  <img
                    src={
                      (scope?.image && !scope?.image.includes("https://storage") && scope?.image) ||
                      projectDefaultIcon
                    }
                  />
                </div>
                <div className="select-sidebar__option-project-info-title">
                  {scopeName}
                </div>
              </div>
              <div className="select-sidebar__option-action">
                {openCompanyMenu ? (
                  <></>
                ) : (
                  <button className="open-company-menu" onClick={() => getCompanies()}>
                    <i className="fi fi-rr-caret-right"></i>
                  </button>
                )}
              </div>
            </>
          ) : (
            <Spinner color="primary" size="xsmall" label="Buscando projetos" />
          )}
        </div>
      </div>
    </div>
  );
};

export default SelectCompanyMobileContainer;